import logo_header_desktop from '../../../assets/imgs/logo_header_desktop.svg'
import logo_small_over_white from '../../../assets/imgs/logo_small_over_white.svg'
import { useAppSelector } from '../../../redux/hooks'
import './style.scss'

function HeaderLogoSearch() {
	const innerWidth: number = useAppSelector(state => state.resize.innerWidth)

	return (
		<div className='header-logo-wrap header-logo-landing-wrap'>
			<a 
				href='/'
				aria-label='link back to home page'
			>
				<img 
					src={innerWidth < 501 ? logo_small_over_white : logo_header_desktop}
					className="header-logo"
					alt="Skivio logo" 
				/>
			</a>
		</div>
	)
}

export default HeaderLogoSearch